import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type {
  UploadFileRequestActionPayload,
  UploadFileResponseActionPayload,
} from 'client/js/redux/domains/FileIngestor/FileIngestor.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';

const UploadFile = new ReduxAsyncAction<
  'FILE_INGESTOR_UPLOAD_FILE',
  UploadFileRequestActionPayload,
  UploadFileResponseActionPayload
>('FILE_INGESTOR_UPLOAD_FILE');

UploadFile.registerRequest(async (payload) => {
  try {
    const formData = new FormData();
    formData.append('file', payload.file);

    const { data } = await dash_api.post<UploadFileResponseActionPayload>('/v1/roi/file-ingestor/upload-file', formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });

    return data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred when uploading the file', 'error');
    throw error;
  }
});

export const UPLOAD_FILE = UploadFile.actionNamespaceConstants;

export const uploadIngestionFile = UploadFile.request;

export type UploadFileResponseAction = Action<typeof UPLOAD_FILE.response> & { data: UploadFileResponseActionPayload };
